import { useStrictLocalization } from "@faire/localization/react/useStrictLocalization";
import { IconButton } from "@faire/slate/components/icon-button";
import { Close } from "@faire/slate-icons/Close";
import React from "react";

type IProps = {
  onClick: () => void;
};

export const MessagingBannerDismissButton: React.FC<IProps> = ({ onClick }) => {
  const { strictLocalize } = useStrictLocalization();

  const dismissLabel = strictLocalize({
    id: "8zNSYz",
    defaultMessage: "Dismiss",
    description: {
      text: "Accessible label for the close button on a messaging banner.",
    },
  });

  return (
    <span className="fs-messaging-banner__dismiss">
      <IconButton
        variant="tertiary"
        size="xxSmall"
        shape="square"
        Icon={Close}
        aria-label={dismissLabel}
        onClick={onClick}
      />
    </span>
  );
};
